import { loadProjects } from "../../../../../../../modules/custom/ev_simulators/js/project/projectCards";
import { hideModal } from "../../common/constants/functions/modalFunctions";
import { getUbicationIDData } from "../../common/constants/interfaces/UbicationInterface";
import { getUserData } from "../../common/constants/interfaces/UserInterface";
import { getNumericValue } from "../../common/constants/variables/globalVariables";
import { ValidateFields } from "../../modules/form/ValidateFields";
class GetDataCalculator {
    constructor(formState) {
        this.formState = formState;
        this.calculos = '';
        this.handleAviVisibility = () => {
            const aviBtn = document.getElementById('avi-fab-wrapper');
            const banner = document.querySelector('.avi-container');
            const bannerBtn = document.querySelector('.js-avi-embed-btn');
            let bannerVisible = false;
            let iframeVisible = false;
            const updateAviButton = () => {
                const shouldHideAvi = bannerVisible || iframeVisible;
                aviBtn === null || aviBtn === void 0 ? void 0 : aviBtn.classList.toggle('show', !shouldHideAvi);
            };
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.target === banner) {
                        bannerVisible = entry.isIntersecting;
                    }
                    if (entry.target instanceof HTMLIFrameElement) {
                        iframeVisible = entry.isIntersecting;
                    }
                });
                updateAviButton();
            });
            if (banner) {
                observer.observe(banner);
            }
            bannerBtn === null || bannerBtn === void 0 ? void 0 : bannerBtn.addEventListener('click', () => {
                const iframe = document.getElementById('avi-chat-frame');
                if (iframe) {
                    observer.observe(iframe);
                }
            });
        };
        this.validateForm = new ValidateFields(formState);
        this.setUpInfoModal = this.setUpInfoModal.bind(this);
        this.calculateFormMortgage = this.calculateFormMortgage.bind(this);
        this.closeCalculusModal = this.closeCalculusModal.bind(this);
    }
    /**
   * Method to load the calculator and set up event listeners for inputs.
   * @returns {void}
   */
    loadCalculator() {
        window.sessionStorage.removeItem('simulatorFormSent');
        let resultsModalInputs = document.querySelectorAll('#resultsFormModal input, .simulator__column-a__body__form input');
        resultsModalInputs.forEach((input) => {
            input.addEventListener('keyup', (e) => {
                this.validateForm.validateInputs(e.target);
            });
        });
    }
    /**
     * Method to set up and configure the info modal.
     * @param {string} calculator - The type of calculator, either 'subsidy' or 'mortgage'.
     * @returns {void}
     */
    setUpInfoModal(calculator) {
        this.formState.manageState('formName', '#calculusModal');
        this.formState.manageState('resultsCalculator', '#calculusModal');
        this.formState.manageState('openCalculator', calculator);
        let inputs = Array.from(document.querySelectorAll(`#calculusModal #resultsFormModal .field-no-vis`));
        let valueFields = calculator == 'simulator-subsidy'
            ? (inputs.forEach(element => element === null || element === void 0 ? void 0 : element.classList.add('d-none')), 2)
            : (inputs.forEach(element => element === null || element === void 0 ? void 0 : element.classList.remove('d-none')), 4);
        let textSimulator = calculator == 'simulator-subsidy' ? 'Subsidio de Vivienda' : 'Crédito Hipotecario';
        this.formState.manageState('valueFields', valueFields);
        document.querySelector('#calculusModal #form-modal-results').disabled = true;
        document.getElementById('value-form-submit').textContent = `Calcular mi ${textSimulator}`;
        document.querySelector('.sending-message-calculator').textContent = `Calculando tu ${textSimulator}`;
    }
    /**
     * Method to change the modal content based on the selected calculator type.
     * @returns {void}
     */
    changeModal() {
        var _a, _b, _c, _d;
        let submitSpan = document.getElementById('value-form-submit');
        (_a = document.querySelector(`#calculusModal #resultsFormModal`)) === null || _a === void 0 ? void 0 : _a.classList.remove('d-none');
        (_b = document.querySelector(`#calculusModal #mortgageResultsModalContainer`)) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
        (_c = document.querySelector(`#calculusModal #subsidyResultsModalContainer`)) === null || _c === void 0 ? void 0 : _c.classList.add('d-none');
        document.getElementById('calculusModalLabel').textContent = 'Diligencia la información para obtener los resultados de tu simulación para ';
        submitSpan === null || submitSpan === void 0 ? void 0 : submitSpan.classList.remove('d-none');
        (_d = document.querySelector(`#calculusModal #resultsFormModal #sending-mss`)) === null || _d === void 0 ? void 0 : _d.classList.add('d-none');
        document.querySelector("#calculusModal input[name='checkboxForm']").value;
        let inputValids = Array.from(document.querySelectorAll('#resultsFormModal input.valid:not(#ingreso)'));
        inputValids.forEach(input => {
            input === null || input === void 0 ? void 0 : input.classList.remove('valid');
        });
        let yearsCards = Array.from(document.querySelectorAll("#calculusModal input[name='plazo']"));
        yearsCards.forEach(item => {
            const inputItem = item;
            if (inputItem.checked) {
                inputItem.checked = false;
            }
        });
        let financialType = Array.from(document.querySelectorAll("#calculusModal input[name='input_credito']"));
        financialType.forEach(item => {
            const inputItem = item;
            if (inputItem.checked) {
                inputItem.checked = false;
            }
        });
        document.querySelector("#calculusModal input[name='checkboxForm']").checked = false;
        let tabsTerms = Array.from(document.getElementsByClassName('nav-link__other'));
        if (tabsTerms.length > 0) {
            tabsTerms.forEach(tab => {
                tab === null || tab === void 0 ? void 0 : tab.classList.remove('active');
            });
        }
    }
    /**
    * Method to close the calculator modal and reset the values.
    * @returns {void}
    */
    closeCalculusModal() {
        let contentModal = document.getElementById('calculusModal');
        let submitModalBtn = document.getElementById('form-modal-results');
        let submitSpan = document.getElementById('value-form-submit');
        let typologyTitle = Array.from(document.getElementsByClassName('calculusModalTypologyName'));
        contentModal === null || contentModal === void 0 ? void 0 : contentModal.setAttribute('data-house-price', '0');
        contentModal === null || contentModal === void 0 ? void 0 : contentModal.setAttribute('data-house-type', '0');
        contentModal === null || contentModal === void 0 ? void 0 : contentModal.setAttribute('data-node-name', '');
        contentModal === null || contentModal === void 0 ? void 0 : contentModal.setAttribute('data-node-id', '');
        contentModal === null || contentModal === void 0 ? void 0 : contentModal.setAttribute('data-percentage', '');
        contentModal === null || contentModal === void 0 ? void 0 : contentModal.setAttribute('data-income', 'not');
        submitModalBtn === null || submitModalBtn === void 0 ? void 0 : submitModalBtn.setAttribute('data-price', '');
        submitModalBtn === null || submitModalBtn === void 0 ? void 0 : submitModalBtn.setAttribute('data-project-id', '');
        submitSpan === null || submitSpan === void 0 ? void 0 : submitSpan.setAttribute('data-price', '0');
        submitSpan === null || submitSpan === void 0 ? void 0 : submitSpan.setAttribute('data-project-id', '0');
        typologyTitle.forEach(title => {
            title.innerHTML = '';
        });
        hideModal('calculusModal');
        this.changeModal();
    }
    /**
     * Calculates the quote for a given element and updates the DOM.
     * @param {number} projectPrice - The project price of the element.
     * @param {boolean} typologyType - The id of the result element.
     * @param {number} downPaymentPercentage - The down payment percentage.
     */
    calculateQuote(projectPrice, typologyType, downPaymentPercentage, yearsTerm) {
        var _a;
        const idInterest = typologyType == 11660 || typologyType == 11801 ? 'visPercentage' : 'novisPercentage';
        const interest = Number(((_a = document.getElementById(idInterest)) === null || _a === void 0 ? void 0 : _a.getAttribute('data-percentage')) || '0');
        const finalInterest = interest / 100;
        const loanValue = projectPrice * (1 - downPaymentPercentage / 100);
        const monthsTerm = yearsTerm * 12;
        const baseTerm = 1 + finalInterest;
        const baseMonthlyInterest = Math.pow(baseTerm, 1 / 12) - 1;
        const monthlyQuote = (loanValue * baseMonthlyInterest) / (1 - Math.pow(1 + baseMonthlyInterest, -monthsTerm));
        return "$ " + Intl.NumberFormat("es-ES").format(Math.trunc(monthlyQuote));
    }
    /**
     * Method to calculate the subsidy for housing based on the family income.
     * @returns {string} - A string with the calculated subsidy details.
     */
    calculateFormSubsidy() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        let formName = this.formState.manageState('formName');
        let form = document.querySelector(formName);
        let salarios = 0;
        let respuesta = '';
        const salario_minimo = '1750905';
        const ingresos = getNumericValue(form.querySelector("input[name='ingreso']").value);
        salarios = Number(ingresos) / Number(salario_minimo);
        const calculatorResults = this.formState.manageState('resultsCalculator');
        const result = document.querySelector(calculatorResults);
        const smmlv_vivienda = salarios <= 2 ? 30 : 20;
        const subsidio_vivienda = Number(smmlv_vivienda) * Number(salario_minimo);
        respuesta = ',\n SMMLV: ' + smmlv_vivienda +
            ',\n Subsidio: $' + new Intl.NumberFormat('es-ES').format(subsidio_vivienda);
        if (salarios <= 4) {
            document.getElementById('value-num-salary').innerHTML = smmlv_vivienda.toString();
            document.getElementById('value-salary').innerHTML = "$ " + new Intl.NumberFormat('es-ES').format(subsidio_vivienda);
            (_a = document.getElementById('text-results-message')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
            (_b = document.getElementById('text-search-action')) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
            (_c = document.getElementById('subsidyOk')) === null || _c === void 0 ? void 0 : _c.classList.remove('d-none');
            document.querySelector('.js-simulator-results #Btn_lqn').textContent = "Quiero obtener mi pre-aprobado en línea";
            (_d = document.getElementById('lqn-complement')) === null || _d === void 0 ? void 0 : _d.classList.add("d-none");
            (_e = document.getElementById('user-resume-title')) === null || _e === void 0 ? void 0 : _e.classList.remove("d-none");
        }
        else if (salarios > 4) {
            respuesta = `,\n No aplica para subsidio`;
            let noSubsidyHTML = `
            <p>Según el cálculo realizado en nuestro simulador, tu perfil no aplica para recibir un subsidio de vivienda, ya que los ingresos o el valor de la vivienda seleccionada están fuera del rango establecido.</p>
            <p>Te invitamos a repetir el cálculo y asegurarte de que todos los datos estén correctos.</p>
            <p><a href="/blog/financiacion" target="_blank" class="link link--under">Conoce aquí sobre subsidios de vivienda</a>`;
            document.getElementById('text-results-message-value').innerHTML = noSubsidyHTML;
            (_f = document.getElementById('text-results-message')) === null || _f === void 0 ? void 0 : _f.classList.remove('d-none');
            (_g = document.getElementById('text-search-action')) === null || _g === void 0 ? void 0 : _g.classList.remove('d-none');
            (_h = document.getElementById('subsidyOk')) === null || _h === void 0 ? void 0 : _h.classList.add('d-none');
            document.querySelector('.js-simulator-results #Btn_lqn').textContent = "Conoce aquí la viabilidad de tu crédito hipotecario";
            (_j = document.getElementById('lqn-complement')) === null || _j === void 0 ? void 0 : _j.classList.remove("d-none");
            (_k = document.getElementById('user-resume-title')) === null || _k === void 0 ? void 0 : _k.classList.add("d-none");
            const userData = getUserData();
            const userName = userData ? userData.name : form.querySelector("input[name='name']").value;
            document.getElementById('resultsTitle').innerHTML = `Hola ${userName}:`;
        }
        this.calculos =
            `Ingresos mensuales: $` + new Intl.NumberFormat('es-ES').format(Number(ingresos)) + respuesta;
        return this.calculos;
    }
    /**
   * Method to calculate the mortgage details based on the selected home price, down payment, interest, and term.
   * @param {number} years - The number of years for the mortgage term.
   * @returns {string} - A string with the calculated mortgage details.
   */
    calculateFormMortgage(years, origen) {
        var _a, _b;
        const formName = this.formState.manageState('formName');
        const form = document.querySelector(formName);
        const calculatorResults = this.formState.manageState('resultsCalculator');
        const isModal = calculatorResults == '#calculusModal';
        let homePrice = 0, interest = 0, typologyType = 0, requireIncome = 'not', downPaymentPercentageValue = 0;
        let firstTermSelected = document.getElementById('firstTermSelectedModal');
        const setModalData = (modal) => {
            var _a;
            homePrice = Number((_a = modal === null || modal === void 0 ? void 0 : modal.getAttribute('data-house-price')) === null || _a === void 0 ? void 0 : _a.replace('.', ''));
            interest = Number(modal === null || modal === void 0 ? void 0 : modal.getAttribute('data-percentage'));
            requireIncome = (modal === null || modal === void 0 ? void 0 : modal.getAttribute('data-income')) || 'not';
            typologyType = Number(modal === null || modal === void 0 ? void 0 : modal.getAttribute('data-house-type')) || 0;
        };
        if (isModal) {
            const modal = document.getElementById('calculusModal');
            setModalData(modal);
        }
        else {
            const price = document.getElementById('price-project');
            homePrice = Number((_a = price === null || price === void 0 ? void 0 : price.value) === null || _a === void 0 ? void 0 : _a.replace(/[^0-9]/g, ''));
            typologyType = homePrice < 249000000 ? 11660 : 20220;
            const nameInterest = homePrice < 249000000 ? 'visPercentage' : 'novisPercentage';
            interest = Number((_b = document.getElementById(nameInterest)) === null || _b === void 0 ? void 0 : _b.getAttribute('data-percentage'));
            firstTermSelected = document.getElementById('firstTermSelected');
            document.getElementById('value-interest').innerHTML = `${interest} %`;
        }
        if (origen == 'sendForm') {
            firstTermSelected === null || firstTermSelected === void 0 ? void 0 : firstTermSelected.classList.add('active');
            const otherOptions = document.querySelectorAll(".simulator__results-time .ev-tabs__item--simulator");
            otherOptions.forEach(option => option === null || option === void 0 ? void 0 : option.classList.remove('active'));
        }
        // Form Data Extraction
        const yearsTerm = years || Number(form.querySelector("input[name='plazo']:checked").value);
        const creditType = form.querySelector("input[name='input_credito']:checked").value;
        downPaymentPercentageValue = creditType === 'Crédito Hipotecario' ? 0.30 : 0.20;
        const downPaymentPercentage = creditType === 'Crédito Hipotecario' ? 30 : 20;
        const financiationOption = document.querySelectorAll('.js-financiation-leasing, .right-button');
        if (creditType == 'Crédito Hipotecario') {
            financiationOption.forEach(element => {
                element.classList.remove('d-none');
            });
        }
        else {
            financiationOption.forEach(element => {
                element.classList.add('d-none');
            });
        }
        if (origen == 'sendForm') {
            firstTermSelected.innerHTML = `${yearsTerm} años`;
        }
        // Financial Calculations
        const downPaymentValue = homePrice * downPaymentPercentageValue;
        const monthTerm = yearsTerm * 12;
        const loanValue = homePrice * (1 - downPaymentPercentageValue);
        const montlyQuote = this.calculateQuote(homePrice, typologyType, downPaymentPercentageValue, yearsTerm);
        const minimumMonthlyIncome = requireIncome === 'not' ? getNumericValue(montlyQuote) * 3.3 : Number(requireIncome);
        const formatCurrency = (value) => `$ ${Intl.NumberFormat("es-ES").format(Math.trunc(value))}`;
        // Formatting and Results
        this.calculos =
            `Préstamo => ${formatCurrency(loanValue)},
            Cuota inicial => ${formatCurrency(downPaymentValue)},
            Ingresos requeridos => ${formatCurrency(minimumMonthlyIncome)},
            Plazo en meses => ${monthTerm},
            Tasa de interés => ${interest} %,
            Cuota mensual crédito => ${montlyQuote}`;
        const result = document.querySelector(calculatorResults);
        let htmlLoanTerm = Array.from(document.getElementsByClassName('js-value-term'));
        let htmlMonthlyFee = Array.from(document.getElementsByClassName('js-value-monthly-fee'));
        htmlLoanTerm.forEach(htmlElement => {
            htmlElement.innerHTML = new Intl.NumberFormat('es-ES').format(Math.round(monthTerm));
        });
        htmlMonthlyFee.forEach(htmlElement => {
            htmlElement.innerHTML = montlyQuote;
        });
        // Update Result Page
        result.querySelector('#value-interest').innerHTML = `${interest} %`;
        result.querySelector('#value-loan').innerHTML = formatCurrency(loanValue);
        result.querySelector('#value-initial-fee').innerHTML = formatCurrency(downPaymentValue);
        result.querySelector('#value-required-income').innerHTML = formatCurrency(minimumMonthlyIncome);
        if (result.querySelector('#form-home-price-page')) {
            result.querySelector('#form-home-price-page').innerHTML = formatCurrency(homePrice);
        }
        if (result.querySelector('#form-down-payment-percentage-page')) {
            result.querySelector('#form-down-payment-percentage-page').innerHTML = `${downPaymentPercentage} %`;
        }
        if (result.querySelector('#form-years-term-page')) {
            result.querySelector('#form-years-term-page').innerHTML = yearsTerm.toString();
        }
        return this.calculos;
    }
    handleModalResults(calculatorName) {
        var _a, _b, _c, _d;
        const calcNameClean = calculatorName === null || calculatorName === void 0 ? void 0 : calculatorName.replace('full-', '');
        const isSubsidy = calcNameClean === 'simulator-subsidy';
        (_a = document.querySelector(`#calculusModal #resultsFormModal`)) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
        (_b = document.querySelector(`#calculusModal #mortgageResultsModalContainer`)) === null || _b === void 0 ? void 0 : _b.classList.toggle('d-none', isSubsidy);
        (_c = document.querySelector(`#calculusModal #subsidyResultsModalContainer`)) === null || _c === void 0 ? void 0 : _c.classList.toggle('d-none', !isSubsidy);
        document.getElementById('calculusModalLabel').textContent = 'Resultados de tu simulación para ';
        const sendingMessage = document.getElementById('sending-mss');
        if (sendingMessage) {
            sendingMessage.innerHTML = isSubsidy
                ? 'Calculando tu Subsidio de Vivienda <div class="lds-dual-ring"></div>'
                : 'Calculando tu Crédito Hipotecario <div class="lds-dual-ring"></div>';
        }
        const calcValueClass = isSubsidy ? 'simulatorSentMortgage' : 'simulatorSentSubsidy';
        (_d = document.querySelector(`.${calcValueClass}`)) === null || _d === void 0 ? void 0 : _d.classList.add('d-none');
    }
    handleInlineResults(calculatorName, resultElement) {
        const formSelector = this.formState.manageState('formName');
        const formElement = document.querySelector(formSelector);
        const simulatorDescription = document.querySelector('.simulator__description');
        const aviContainer = document.querySelector('.avi-container');
        if (formElement)
            formElement.style.display = 'none';
        resultElement.style.display = 'block';
        aviContainer.classList.remove('d-none');
        simulatorDescription.style.display = 'none';
        calculatorName = calculatorName === null || calculatorName === void 0 ? void 0 : calculatorName.replace('full-simulator', '');
        resultElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
    buildLQNHref(formData, formID) {
        const paramsWhiteBrand = new URLSearchParams(window.location.search);
        const existsWhiteBrand = paramsWhiteBrand.get('product') == 'fair-white-brand';
        const whiteBrand = window.location.pathname.includes('/feria-propia/') || existsWhiteBrand;
        let referrer = '';
        if (whiteBrand) {
            const titleWhiteBrand = document.getElementById('titleWhiteBrand');
            const refererWhiteBrand = titleWhiteBrand ? titleWhiteBrand.getAttribute('data-title') : '';
            referrer = refererWhiteBrand ? refererWhiteBrand + ' - Ferias propias' : 'Ferias propias';
        }
        const params = new URLSearchParams({
            nombres: formData.name,
            apellidos: formData.lastName,
            numero_celular: formData.phone,
            correo_electronico: formData.mail,
            tipologia: formID,
            referencia: referrer
        });
        const urlLQN = whiteBrand ? '/preaprobacion-en-linea-feria-propia' : '/preaprobacion-en-linea';
        return `${urlLQN}?${params.toString()}`;
    }
    loadSimulatorProject(calculatorName) {
        var _a;
        let locationFilter = '';
        calculatorName = calculatorName === null || calculatorName === void 0 ? void 0 : calculatorName.replace('full-simulator', '');
        const price = getNumericValue((_a = document.getElementById('price-project')) === null || _a === void 0 ? void 0 : _a.value);
        const firstRangePrice = calculatorName == '-subsidy' ? '90000000' : price - (price * 0.4);
        const secondRangePrice = calculatorName == '-subsidy' ? '250000000' : price;
        const ubicationValues = getUbicationIDData();
        const cityID = ubicationValues === null || ubicationValues === void 0 ? void 0 : ubicationValues.cityID;
        const zoneID = ubicationValues === null || ubicationValues === void 0 ? void 0 : ubicationValues.zoneID;
        const sectorID = ubicationValues === null || ubicationValues === void 0 ? void 0 : ubicationValues.sectorID;
        if (cityID && cityID !== 'all')
            locationFilter += `&cities=${cityID}`;
        if (zoneID && zoneID !== 'all')
            locationFilter += `&zone=${zoneID}`;
        if (sectorID && sectorID !== 'all')
            locationFilter += `&sector=${sectorID}`;
        let urlProjects = `/results-api?section_type=property_type&price=${firstRangePrice},${secondRangePrice}&${locationFilter}&range=4`;
        loadProjects('simuladores', urlProjects);
    }
    showResultsCalculator(formData) {
        const formID = this.formState.manageState('typologyId');
        let calculatorName = this.formState.manageState('openCalculator');
        const resultSelector = this.formState.manageState('resultsCalculator');
        const isModal = resultSelector === '#calculusModal';
        const resultElement = document.querySelector(resultSelector);
        if (!resultElement)
            return;
        const simulatorImage = document.getElementById('js-simulator-image');
        if (simulatorImage) {
            simulatorImage.src = '/themes/custom/ev_theme/assets/images/simulator/resultados-simuladores.webp';
        }
        const lqnButton = resultElement.querySelector('#Btn_lqn');
        if (lqnButton) {
            lqnButton.href = this.buildLQNHref(formData, formID);
        }
        if (isModal) {
            this.handleModalResults(calculatorName);
        }
        else {
            this.handleInlineResults(calculatorName, resultElement);
            // load simulator project
            this.loadSimulatorProject(calculatorName);
        }
    }
    sendUserDataToAVI(formData, sidCalculator) {
        var _a, _b;
        const habitar_invertir = formData.habitar_invertir == 1 ? 'Habitar' : 'Invertir';
        const aviData = {
            name: formData.name || "",
            lastName: formData.lastName || "",
            fullName: `${formData.name || ""} ${formData.lastName || ""}`.trim(),
            phone: formData.phone || "",
            email: formData.mail || "",
            countryCode: formData.countryCode || "+57",
            budget: formData.precio || "",
            income: getNumericValue(formData.IngresosFamiliares) || "",
            city: formData.ciudad || "",
            zone: formData.zona_interes || "",
            sector: formData.sector_interes || "",
            habitar_invertir: habitar_invertir !== null && habitar_invertir !== void 0 ? habitar_invertir : "",
            nameCalculator: (_a = formData.nameCalculator) !== null && _a !== void 0 ? _a : "",
            calculos: (_b = formData.calculos) !== null && _b !== void 0 ? _b : "",
            origin: 'AVI - ' + formData.nameCalculator,
            sidCalculator: sidCalculator,
        };
        const floatIframe = document.getElementById("avi-chat-float-frame");
        if (floatIframe === null || floatIframe === void 0 ? void 0 : floatIframe.contentWindow) {
            floatIframe.contentWindow.postMessage({
                type: "AVI_USER_DATA",
                payload: aviData,
            }, "*");
        }
        sessionStorage.setItem("aviUserData", JSON.stringify(aviData));
    }
}
export { GetDataCalculator };
